"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Facebook, Instagram, Linkedin, Twitter, MapPin, Phone, Mail, Loader } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="16027" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-24 bg-muted animate-pulse rounded-sm" />)}
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-sans" data-index={i}>
          {item.label}
        </Link>)}
    </nav>;
}
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-4 bg-accent/10 border border-accent/20 rounded-sm">
        <p className="text-sm text-primary font-medium">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
      <FormField control={control} name="nome" render={({
      field
    }) => <FormItem>
            <FormControl>
              <Input placeholder="Nome" {...field} className="bg-muted border-border focus-visible:ring-primary text-sm rounded-sm" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "L'email è obbligatoria",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Inserisci un'email valida"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormControl>
              <Input type="email" placeholder="Email" {...field} className="bg-muted border-border focus-visible:ring-primary text-sm rounded-sm" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="consenso_marketing" rules={{
      required: "È necessario il consenso per procedere"
    }} render={({
      field: {
        value,
        onChange,
        ...field
      }
    }) => <FormItem className="flex flex-row items-start space-x-3 space-y-0">
            <FormControl>
              <input type="checkbox" checked={value} onChange={onChange} className="mt-1 h-4 w-4 rounded-sm border-border text-primary focus:ring-primary accent-primary" {...field} />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel className="text-xs text-muted-foreground font-normal">
                Acconsento al trattamento dei dati per comunicazioni tecniche
              </FormLabel>
              <FormMessage />
            </div>
          </FormItem>} />

      {submitError && <p className="text-xs text-destructive">{submitError}</p>}

      <Button type="submit" disabled={isSubmitting} className="w-full bg-primary text-primary-foreground hover:opacity-90 rounded-sm h-10 font-sans font-semibold uppercase tracking-wider text-xs">
        {isSubmitting ? <>
            <Loader className="mr-2 h-4 w-4 animate-spin" />
            Invio in corso...
          </> : "Iscriviti agli aggiornamenti"}
      </Button>
    </Form>;
}
export default function PieDiPagina() {
  return <footer id="footer-informativo" className="dark bg-background pt-20 pb-10 border-t border-border">
      <div className="container mx-auto px-4 max-w-[1200px]">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12 mb-16">
          
          {}
          <div className="flex flex-col gap-6 col-span-2 md:col-span-1">
            <div className="mb-2">
              <img src="https://equipped-egret.10web.cloud/wp-content/uploads/2026/03/image_cieydgl1.png" alt="B-Tech IT Consulting" className="object-contain brightness-0 invert !w-[100px] !h-[100px]" />
            </div>
            <div className="hidden md:flex flex-col gap-6">
              <h3 className="font-semibold text-foreground text-sm uppercase tracking-widest font-sans">Navigazione</h3>
              <MenuProvider menu_id="48" className="w-full">
                <FooterMenuConsumer />
              </MenuProvider>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6 md:hidden col-span-1">
            <h3 className="font-semibold text-foreground text-sm uppercase tracking-widest font-sans">Navigazione</h3>
            <MenuProvider menu_id="48" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6 col-span-1">
            <h3 className="font-semibold text-foreground text-sm uppercase tracking-widest font-sans md:pt-9">Competenze</h3>
            <nav className="flex flex-col gap-3">
              {[{
              label: "Infrastrutture IT",
              href: "/ServicesPage"
            }, {
              label: "Cybersecurity",
              href: "/ServicesPage"
            }, {
              label: "Gestione Dispositivi",
              href: "/ServicesPage"
            }, {
              label: "Tecnologie Logistiche",
              href: "/SolutionsPage"
            }, {
              label: "Governance IT",
              href: "/ExperiencePage"
            }, {
              label: "Deployment Sistemi",
              href: "/ServicesPage"
            }].map((link, i) => <Link key={i} to={link.href} className="text-muted-foreground hover:text-primary transition-colors text-sm font-sans" data-index={i}>
                  {link.label}
                </Link>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6 col-span-1">
            <h3 className="font-semibold text-foreground text-sm uppercase tracking-widest font-sans md:pt-9">Supporto Consulenziale</h3>
            
            <div className="flex flex-col gap-4 text-sm text-muted-foreground font-sans">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 shrink-0 text-primary" />
                <span>Voghera, Italia</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 shrink-0 text-primary" />
                <span>+39 377 088 4303</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 shrink-0 text-primary" />
                <span>info@b-tech.it</span>
              </div>
            </div>

            <div className="flex gap-4 mt-2">
              {[{
              icon: Linkedin,
              href: "#"
            }, {
              icon: Twitter,
              href: "#"
            }, {
              icon: Facebook,
              href: "#"
            }, {
              icon: Instagram,
              href: "#"
            }].map((social, i) => <Link key={i} to={social.href} className="w-8 h-8 flex items-center justify-center rounded-sm border border-border text-foreground hover:bg-primary hover:text-primary-foreground transition-all shadow-sm" data-index={i} aria-label="Social Media Link">
                  <social.icon className="w-4 h-4" />
                </Link>)}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6 col-span-2 lg:col-span-1">
            <h3 className="font-semibold text-foreground text-sm uppercase tracking-widest font-sans md:pt-9">Aggiornamenti B2B</h3>
            <p className="text-sm text-muted-foreground leading-relaxed font-sans">Iscriviti per ricevere aggiornamenti e approfondimenti&nbsp;<span style={{
              color: 'rgb(148, 163, 184)',
              letterSpacing: '-0.32px'
            }}>su infrastrutture IT, sicurezza e tecnologie operative.</span></p>
            
            <FormProvider formId="newsletter_form_home" sectionName="footer-newsletter" defaultValues={{
            nome: "",
            email: "",
            consenso_marketing: false
          }} validationRules={{
            email: {
              required: true,
              pattern: "email"
            },
            consenso_marketing: {
              required: true
            }
          }} submitText="Iscriviti" successMessage="Iscrizione completata con successo." errorMessage="Si è verificato un errore tecnico. Riprova." className="w-full">
              <NewsletterForm />
            </FormProvider>
          </div>

        </div>

        <Separator className="bg-border" />

        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground font-mono">
          <p>© 2026 B-Tech IT. P.IVA 02984270187.</p>
          <div className="flex gap-6 uppercase tracking-tighter">
            <Link to="https://www.iubenda.com/privacy-policy/34480463" className="iubenda-black iubenda-noiframe iubenda-embed hover:text-primary transition-colors" title="Privacy Policy ">Privacy Policy</Link>
            <script type="text/javascript" dangerouslySetInnerHTML={{
            __html: `(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);`
          }} />
            <Link to="https://www.iubenda.com/privacy-policy/34480463/cookie-policy" className="iubenda-black iubenda-noiframe iubenda-embed hover:text-primary transition-colors" title="Cookie Policy ">Cookie Policy</Link>
            <script type="text/javascript" dangerouslySetInnerHTML={{
            __html: `(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);`
          }} />
            
          </div>
        </div>
      </div>
    </footer>;
}